import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { SortableItem } from "./SortableItem";
import { useDroppable } from "@dnd-kit/core";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DropPlaceHolder from "./DropPlaceholder";
import { useStore } from "react-redux";
import { useScreenSize } from "../../components/Atoms/ScreenSizeHook";


function Column({ colId, items, expanded, onToggle, activeId, showEquipment, isFocused, unassignedNotification, handleClickFromUnassignedMenuList, handleUserClick,_users }) {
  const { setNodeRef, isOver } = useDroppable({ id: colId });

  let isUnassigned = colId === "unassignedNotification";

  const store = useStore().getState();

  const { windowWidth, breakpoint } = useScreenSize();

  let colSize = 12;



  if (windowWidth <= 3900 ) {
    colSize = isFocused ? 1.5 : 4; // lg

    if (windowWidth <= 3500 ) {
      colSize = isFocused ? 2 : 4; // lg
    }  

    if (windowWidth <= 1920 ) {
      colSize = isFocused ? 3 : 4; // lg
    } 

    if (windowWidth <= 1440 ) {
      colSize = isFocused ? 4 : 6; // lg
    } 
  }
  


  const getUserName = (colid) => {
    let userName = "";
    if (_users) {
      _users.map((usr) => {
        if (usr.user.nodeid === colid) {
          userName = usr.user.givenname + " " + usr.user.surname;
        }
      })
    }
    return userName;
  }


  return (
    <div
      ref={setNodeRef}
      style={{ width: "100%", transition: "background 0.3s ease" }}
    >


      <Accordion
        expanded={expanded}
        onChange={onToggle}
        defaultExpanded={true}
        id={`accordion-${colId}`}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-${colId}-content`}
          id={`panel-${colId}-header`}
        >
          <Typography
            className={
              isUnassigned ? "dndn_planner_unassigned" : "dnd_planner_title"
            }
          >
            {isUnassigned ? "Nicht zugeordnete Meldungen" : getUserName(colId)}
          </Typography>
          <Typography className="dnd_planner_counting">
            {items?.length + (items?.length ? " Aufgaben" : " Aufgabe")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails >
          <SortableContext items={items} strategy={rectSortingStrategy} scrollable>

            <div
              id="dndlist"
              className="dndlist"
              style={{
                background: isOver ? "#d4d8d9" : isUnassigned && items.length ? "#FFFFFF" : "#F4F4F4",
                padding: isUnassigned ? (items.length ? "3px" : "8px") : "8px"
              }}
            >
              {items?.length ? (
                <>
                  {
                    isUnassigned ? <Grid
                      container
                      spacing={1}
                      sx={{
                        padding: isUnassigned ? "0px" : "4px",
                        background: isOver ? "#d4d8d9" : isUnassigned ? "#FFFFFF" : "#F4F4F4",
                        borderRadius: "8px",
                        flexDirection: "row",
                        border:
                          items.length === 0 ? "2px dashed #cbd5e1" : "none",
                        transition: "background 0.2s ease",
                      }}
                    >
                      {items.map((item) => (
                        <Grid item
                          xs={colSize}
                          key={`${colId}-${item.nodeid}`} sx={{ background: isOver ? "#d4d8d9" : isUnassigned ? "#FFFFFF" : "#F4F4F4", padding: "4px" }}>
                          <SortableItem _users={_users} showEquipment={showEquipment} colId={colId} id={item?.nodeid} item={item} handleUserClick={handleUserClick} />
                        </Grid>
                      ))}
                    </Grid> : items?.map((item) => (
                      <SortableItem _users={_users} showEquipment={showEquipment} colId={colId} id={item?.nodeid} item={item} key={`${colId}-${item.nodeid}`} handleUserClick={handleUserClick} />
                    ))
                  }</>

              ) : (
                <DropPlaceHolder isOver={isOver} colId={colId} key={`empty-${colId}`} unassignedNotification={unassignedNotification} handleClickFromUnassignedMenuList={handleClickFromUnassignedMenuList} />
              )}
            </div>


          </SortableContext>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
export default Column;
